import { Survey } from 'app/survey';

export class SessionSurvey {
  constructor(
    public survey: Survey,
    public surveyStartDate: Date,
    public surveyEndDate?: Date,
    public surveyStatus?: string
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session-survey.model.ts